<div>
    @if(isLoading) {
    <app-loading-indicator />
    } @else {
        <div class="control-row">
            <div class="control mx-5">
              <label class="mb-1" for="selectTarget" style="font-weight: bold; color: #719eb6"
                >Select more than one target or behavior to start comparison mode:</label
              >
              <p-multiSelect
                id="selectTarget"
                styleClass="w-100 mb-3"
                appendTo="body"
                [options]="selectableTargets()"
                [(ngModel)]="selectedTargets"
                name="selectedTargets"
                optionLabel="text"
                optionValue="value"
                [showClear]="true"
                placeholder="Select Targets here"
                [filter]="true"
                filterBy="text"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                [loading]="isLoading"
                [disabled]="isLoading"
                ><ng-template pTemplate="selectedTarget" let-selectedOption>
                  <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.text }}</div>
                  </div>
                </ng-template>
              </p-multiSelect>
              
              <br>

              <p-multiSelect
                id="selectBehavior"
                styleClass="w-100 mb-3"
                appendTo="body"
                [options]="selectableBehaviors()"
                [(ngModel)]="selectedBehaviors"
                name="selectedBehaviors"
                optionLabel="text"
                optionValue="value"
                [showClear]="true"
                placeholder="Select Behaviors here"
                [filter]="true"
                filterBy="text"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                [loading]="isLoading"
                [disabled]="isLoading"
                ><ng-template pTemplate="selectedBehavior" let-selectedOption>
                  <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.text }}</div>
                  </div>
                </ng-template>
              </p-multiSelect>

              <br>

              <div class="col-12 mb-3">
                <button
                    (click)="onGraphClick()"
                    class="side-menu-button2 selected w-100 mt-2"
                    id="graphButton"
                >
                    Graph!
                </button>
                </div>
            </div>
          </div>
        <app-mixed-graph
          #mixedGraph
          [patientID]="patientID()"
          [selectedTargets]="selectedTargets()"
          [selectedBehaviors]="selectedBehaviors()"
        ></app-mixed-graph>
      }
    </div>